<template>
  <DefaultLayout>
    <template v-slot:title>
      Projects
    </template>
    <div class="flex mb-4">
      <search placeholder="Search projects" />
      <div class="flex-grow flex justify-end"><Button to="/add-project">New Project</Button></div>
    </div>
    <div v-if="this.$store.state.projects.length">
      <div v-for="project in projects" :key="project.id">
      <p>Here are your projects:</p>
        {{ project.name }}

      </div>
    </div>
    <div v-else>
      <p class="text-center text-gray-600">You don't have any projects yet.</p>
    </div>

  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/components/layouts/DefaultLayout.vue'
import Button from '@/components/shared/Button.vue'
import Search from '@/components/shared/Search.vue'

export default {
  name: 'ProjectListing',
  components: {
    DefaultLayout,
    Button,
    Search
  },
  computed: {
    projects () {
      return this.$store.state.projects
    }
  },
  created () {
    this.$store.dispatch('getProjects')
  }
}

</script>
